import { useFeatureFlagEnabled } from "posthog-js/react"

export const useFeatureFlag = (featureFlagName: string) => {
  return useFeatureFlagEnabled(__DEV__ ? `${featureFlagName}-trysynch` : featureFlagName)
}
